import countryISOCodes from "@wingspanhq/users/dist/lib/services/fixtures/country-iso-codes-list.json";

export const selectorCountryName = (alpha2Code: string) =>
  countryISOCodes.find(country => country["alpha-2"] === alpha2Code)?.name;
